const EntityFormModalMainTestIdsScope = {
  ENTITY_FORM_MODAL_MAIN: 'entity-form-modal-main',
};

export const EntityFormModalMainTestIds = {
  CANCEL_BUTTON: `${EntityFormModalMainTestIdsScope.ENTITY_FORM_MODAL_MAIN}.cancel-button`,
  APPLY_BUTTON: `${EntityFormModalMainTestIdsScope.ENTITY_FORM_MODAL_MAIN}.apply-button`,
  SAVE_BUTTON: `${EntityFormModalMainTestIdsScope.ENTITY_FORM_MODAL_MAIN}.save-button`,
  NAVIGATION_SELECT: `${EntityFormModalMainTestIdsScope.ENTITY_FORM_MODAL_MAIN}.navigation-select`,
};
